import { useEffect, useState } from "react";

const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.hlrothptyltd.recoverapp";
const APP_STORE = "https://apps.apple.com/au/app/recover-anxiety-depression/id6759235833";

function getStoreUrl(): { url: string; label: string } | null {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return { url: PLAY_STORE, label: "Google Play Store" };
  if (/iPad|iPhone|iPod/.test(ua)) return { url: APP_STORE, label: "App Store" };
  return null;
}

export default function OpenAppPage() {
  const [store, setStore] = useState<{ url: string; label: string } | null>(null);

  useEffect(() => {
    window.location.href = "recoverapp://recoverapp.com";
    setStore(getStoreUrl());
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#E8F1F5] via-[#D1E3EA] to-[#F0F4F8] flex items-center justify-center px-6">
      <div className="text-center space-y-6">
        <div className="inline-flex items-center justify-center w-24 h-24 bg-white rounded-3xl shadow-xl mb-4">
          <i className="ri-smartphone-line text-5xl text-[#2F7FB7]"></i>
        </div>
        <h1 className="text-4xl font-serif text-[#2F7FB7]">Opening RECOVER...</h1>
        <p className="text-[#4A5568] text-lg max-w-sm mx-auto">
          If the app didn't open,{" "}
          <a href="recoverapp://recoverapp.com" className="text-[#2F7FB7] underline">
            try clicking here
          </a>{" "}
          to launch it.
        </p>
        <p className="text-sm text-[#6B7280]">
          Don't have the app yet?{" "}
          {store ? (
            <a href={store.url} target="_blank" rel="noopener noreferrer" className="text-[#2F7FB7] underline">
              Download from the {store.label}
            </a>
          ) : (
            <>
              <a href={APP_STORE} target="_blank" rel="noopener noreferrer" className="text-[#2F7FB7] underline">
                App Store
              </a>
              {" or "}
              <a href={PLAY_STORE} target="_blank" rel="noopener noreferrer" className="text-[#2F7FB7] underline">
                Google Play
              </a>
            </>
          )}
        </p>
      </div>
    </div>
  );
}
